export default __webpack_public_path__ + "static/media/card-time-icon.653fc117.svg";